@if (hasAtgarder) {
  <rask-cards>
    @for (atgard of sortBy('beteckning'); track atgard) {
      @if (!isGrot && !isLeveransvirke) {
        <rask-arbetsorder-atgard-produktion-avslutad-rv
          [atgard]="atgard"
          [rootForm]="rootForm"
          [arbetsorder]="arbetsorder">
        </rask-arbetsorder-atgard-produktion-avslutad-rv>
      }
      @if (isGrot) {
        <rask-arbetsorder-atgard-produktion-avslutad-grot
          [atgard]="atgard"
          [rootForm]="rootForm"
          [arbetsorder]="arbetsorder">
        </rask-arbetsorder-atgard-produktion-avslutad-grot>
      }
      @if (isLeveransvirke) {
        <rask-arbetsorder-atgard-produktion-avslutad-lev
          [atgard]="atgard"
          [arbetsorder]="arbetsorder">
        </rask-arbetsorder-atgard-produktion-avslutad-lev>
      }
    }
  </rask-cards>
}

